/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
//import { useEffect, useState, lazy, Suspense } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams, BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { Dimmer, Loader, Button, Modal } from "semantic-ui-react";
import { TextField } from '@mui/material';
import axiosInstance from './functions/axiosInstance';
import firebase from 'firebase/compat/app';
import { getAuth, getIdToken, signInWithPopup, signInWithCustomToken, signInWithEmailAndPassword, createUserWithEmailAndPassword, onAuthStateChanged, sendEmailVerification, sendPasswordResetEmail } from "firebase/auth";
//import { Counter } from "./slices/counter/Counter"
//import { Quotes } from "./slices/quotes/Quotes"
import PageTitle from "./components/PageTitle";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SidePanel from "./components/SidePanel";
import Homepage from "./components/Homepage";
import About from "./components/About";
import CompanyLaunch from "./components/CompanyLaunch";
import Mission from "./components/Mission";
import Products from "./components/Products";
import { Media } from "./slices/media/Media";
import SingleMediaPage from "./slices/media/SingleMediaPage";
import { changeEnvironment } from "./slices/environment/environmentSlice";
import { addMediaListeners } from "./slices/media/mediaSlice";
import { addReleaseNotesListeners } from "./slices/releaseNotes/releaseNotesSlice";
import { addResourceCollectionListeners } from "./slices/resourceCollection/resourceCollectionSlice";
import { selectCurrentUserApiToken, selectCurrentUserId, userLoggedIn, userLoggedOut, selectWebsiteView, selectCurrentUserAdmin, selectCurrentUserM11Use, selectDisplayTheTermsOfAgreement } from "./slices/currentUser/currentUserSlice";
import { ReleaseNotesPage } from "./slices/releaseNotes/ReleaseNotesPage";
import { EditReleaseNotePage } from "./slices/releaseNotes/EditReleaseNoteForm";
import FEvIRHomePage from "./components/FEvIRHomePage";
import SearchQueryPage from "./components/SearchQueryPage";
import ResourceDisplayPage from "./resourceComponents/ResourceDisplayPage";
import { selectBrowserTabTitle } from "./slices/browserTabTitle/browserTabTitleSlice";
import FOIPage from "./components/FOIPage";
import ContentResourcesPage from "./components/ContentResourcesPage";
import SavedSearchesPage from "./components/SavedSearchesPage";
import MedlineConvertPage from "./components/MedlineConvertPage";
import CTgovConvertPage from "./components/CTgovConvertPage";
import CtisConvertPage from "./components/CtisConvertPage";
import MAGICtoFEvIRConverterPage from "./components/MAGICtoFEvIRConverterPage";
import GradeProConverterPage from "./components/GradeProConverterPage";
import RIStoFEvIRConverterPage from "./components/RIStoFEvIRConverterPage";
import DocxToJsonSectionsConverterPage from "./components/DocxToJsonSectionsConverterPage";
import MyBallotPage from "./components/MyBallotPage";
import CreateResourcePage from "./resourceComponents/CreateResourcePage";
import { selectComponentLoading, selectGlobalLoading } from "./slices/globalLoading/globalLoadingSlice";
import { compositionTypeCodeGuideline, compositionTypeCodeRecommendation } from "./dictionaries/CodeSystemLookup";
import ProfilesByResourceType from "./dictionaries/ProfilesByResourceType";
import CreateNewCitationPage from "./components/CreateNewCitationPage";
import CreateCodeableConceptJsonPage from "./components/CreateCodeableConceptJsonPage";
import ProfileSpecificCreateResourcePage from "./resourceComponents/ProfileSpecificCreateResourcePage";
import ApiDocumentationPage from "./components/FevirAPIdocumentation";
import FliToFoiPage from "./components/FliToFoiPage";
import AdminPage from './components/AdminPage';
import AdminPage2 from './components/AdminPage2';
import AdminPage3 from './components/AdminPage3';
import { addNotificationsListeners } from './slices/notifications/notificationsSlice';
import AlertModal from './components/AlertModal';
import TermsOfAgreementPage from './components/TermsOfAgreementPage';
import EditUserProfilePage from './components/EditUserProfilePage';
import UserRemovalPage from './components/UserRemovalPage';
import TermsOfUsePage from './components/TermsOfUsePage';
import PersonalDataAgreementPage from './components/PersonalDataAgreementPage';
import MeasuringTheRateCreationPage from './components/MeasuringTheRateCreationPage';
import MeasuringTheRatePage from './components/MeasuringTheRatePage';
import JsonBulkEntryPage from './components/JsonBulkEntryPage';
import InvitedToResourcePage from './components/InvitedToResourcePage';
import TestingSpacePage from './components/TestingSpacePage';
import server_config from './ServerConfiguration';
import "./App.css";
import { addBaselineRiskListeners } from './slices/baselineRisk/baselineRiskSlice';
import { addOutcomeVariablesListeners } from './slices/outcomeVariables/outcomeVariablesSlice';
import { addSavedSearchesListeners } from './slices/savedSearches/savedSearchesSlice';
import CreateComparativeEvidenceSynthesisReport from './resourceComponents/compositionResourceComponents/CreateComparativeEvidenceSynthesisReport';
import UDPPage from './components/UDPPage';
import CreateComparativeEvidenceReport from './resourceComponents/compositionResourceComponents/CreateComparativeEvidenceReport';
import USDMtoFEvIRConverterPage from './components/USDMtoFEvIRConverterPage';
import M11SidePanel from './components/M11SidePanel';
import M11ReportPage from './resourceComponents/m11ReportComponents/M11ReportPage';
import M11ReportAuthoringTool from './resourceComponents/m11ReportComponents/M11ReportAuthoringTool';

//import "./Table.css"; //Uncomment this if you're ready

const fevir_node_server_address = server_config["fevir_node_server_address"];
const fevir_go_server_address = server_config["fevir_go_server_address"];
const computablepublishing_website_address = server_config["computablepublishing_website_address"];

//const GetCompositionByFOI = lazy(() => import("./components/GetCompositionByFOI"));
//const GetBundleByFOI = lazy(() => import("./components/GetBundleByFOI"));

const RemoveTrailingCharacters = () => { //Removes trailing slash, period, space, %20, and index.html from the end of the url (it also removes multiple slashes, spaces and etc.)
  const trailingRegex = /(\/index\.html|[\/\.\s]|%20)+$/;
  if (window.location.pathname.match(trailingRegex)) {
    const newPath = window.location.pathname.replace(trailingRegex, "") || "/";
    if (newPath !== window.location.pathname) {
      return <Navigate to={newPath} replace />;
    }
  }
  return null;
};

const RedirectSite = ({ page }) => {
  //window.location.href = page;
  window.location.assign(page);
  return <></>;
};

const NetBenfitRedirect = () => {
  const { foi } = useParams();
  useEffect(() => {

    if (window.location.href.includes("dev.fevir.net") || window.location.href.includes("localhost")) {
      window.location.replace("https://dev.netbenefitcalculator.com/" + foi);
    } else {
      window.location.replace("https://netbenefitcalculator.com/" + foi);
    }
  }, [foi]);
  return <></>;
};

const getFevirUserPayload = async (idToken, previousUrlState, setPreviousUrlState, redirect = false, agreetoterms = false) => {    //Similar to continuedSessionLogin from the old FEvIR build
  let returningdata = false;
  const body = {
    'functionid': "login",
    'idToken': idToken,
    'agreetoterms': agreetoterms ?? false,
    'getApiToken': true
  };
  try {
    //console.log("CALLING SERVER with login");
    let resp = await axiosInstance({
      method: 'POST',
      url: fevir_go_server_address,
      timeout: 8000,
      data: body,
    });
    if (resp?.data?.success) {
      let loadedData = resp.data;
      if (loadedData.displaythetermsofagreement) {    //If the user is signing on for the first time, then display the terms of agreement page
        //DISPLAY THE TERMS OF AGREEMENT
      } else {
        loadedData.displaythetermsofagreement = false;
      }
      if (!loadedData.termsofuseaccept || loadedData.termsofuseaccept.slice(-1) < "2026-04-30") {
        loadedData.displaythetermsofagreement = true;
        let previousUrl = window.location.href;
        if (previousUrl.indexOf("termsofagreement") === -1) {
          setPreviousUrlState(previousUrl);
        }
      }
      returningdata = {
        userId: loadedData.id,
        name: loadedData.name,
        userPublicDetail: {
          shortbio: loadedData.shortbio,
          affiliations: loadedData.affiliations
        },
        userPrivateDetail: {
          displaythetermsofagreement: loadedData.displaythetermsofagreement,
          termsofuseaccept: loadedData.termsofuseaccept,
          datapersonalagreementaccept: loadedData.datapersonalagreementaccept,
          email: loadedData.email,
          notificationemail: loadedData.notificationemail,
          additionalemail: loadedData.additionalemail,
          status: loadedData.status,
          admin: loadedData.admin,
          idToken: idToken,
          apiToken: loadedData.apiToken,
          favoritefois: loadedData.favoritefois,
          notificationfois: loadedData.notificationfois,
          numberunreadnotifications: loadedData.numberunreadnotifications,
          numberunclearednotifications: loadedData.numberunclearednotifications,
          m11use: loadedData.m11use
        }
      }
    }
  } catch (e) {
    console.log(e);
    returningdata = false;
  }
  return returningdata;
}

/* Made defunct due to AI improvement
const loadCustomToken = async (customToken, setIdTokenState = undefined) => {
  let returningdata;
  try {
    const auth = getAuth();
    await signInWithCustomToken(auth, customToken).then(async (userCredential) => {
      try {
        const { currentUser } = auth;
        await getIdToken(currentUser,  true).then(async (idToken) => {
          returningdata = idToken;
          if (idToken && setIdTokenState) {
            setIdTokenState({ "idToken": idToken, "tokenPresent": true });
          }
        }).catch(e => { console.log(e); });
      } catch (e) { console.log(e); }
    }).catch(e => { console.log(e); }); //.finally((result) => { console.log(result); });
  } catch (e) { console.log(e); }
  return returningdata;
}
*/

const createCustomToken = async (idToken = null, apiToken = null) => {
  const body = {
    'functionid': 'createssocustomtoken',
    'idToken': idToken,
    'apiToken': apiToken
  };
  return await axiosInstance({
    method: 'POST',
    url: fevir_node_server_address,
    timeout: 10000,
    data: body,
  }).then((resp) => {
    if (resp?.data?.success) {
      return resp.data.code;
    }
  }).catch(e => { console.log(e); });
}

const getCustomToken = async (code) => {
  let customToken;
  const body = {
    'functionid': 'retrievessocustomtoken',
    'code': code
  };
  try {
    //console.log("CALLING SERVER with retrievessocustomtoken")
    const resp = await axiosInstance({
      method: 'POST',
      url: fevir_node_server_address,
      timeout: 10000,
      data: body,
    });
    if (resp?.data?.success) {
      customToken = resp.data.customToken;
    }
  } catch (e) {
    console.log("Error getting custom token:", e);
  }
  return customToken;
}

const processCustomTokenCode = async (code) => {
  window.history.replaceState({}, document.title, window.location.pathname); //Clears the parameters
  if (code) {
    let customToken = await getCustomToken(code);
    if (customToken) {
      try {
        const auth = getAuth();
        await signInWithCustomToken(auth, customToken);
      } catch (error) {
        console.error("Error signing in with custom token:", error);
      }
    } else {
      console.error("Failed to retrieve custom token for the provided code.");
    }
  }
}

const loadUserDataToSlice = async (idToken, previousUrlState, setPreviousUrlState, dispatch, redirect = false) => {
  if (idToken) {
    let fevirUserPayload = await getFevirUserPayload(idToken, previousUrlState, setPreviousUrlState, redirect, false);
    if (fevirUserPayload) {
      dispatch(userLoggedIn(fevirUserPayload));
    } else {
      //Will attempt
      console.error("Failed to get user payload from server.");
    }
  }
}
/*
const ScrollToTop = ({}) => {
    const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
*/

const googleSignInFirebase = async (firebaseGoogleProvider, firebaseEmailAuthProvider, dispatch,
  setUserLoadingState, setAlertModalState, previousUrlState, setPreviousUrlState, redirect = false) => {
  //let returningData = {"success": true}
  const auth = getAuth();
  signInWithPopup(auth, firebaseGoogleProvider).then((result) => {
    let user = result.user;
    if (user) {
      userLogin(dispatch, setUserLoadingState, previousUrlState, setPreviousUrlState, redirect);
      /* //I didn't need to do it in this commented out way
      firebase.auth().currentUser.getIdToken(true).then(async (idToken) => {  //true means force refresh
        //await cpLogin(idToken, globalContext, false);
        success = true;
      }).catch((e) => { console.log(e); });
      */
    }
  }).catch((e) => {
    let errorCode = e.code;
    let errorMessage = e.message;
    if (errorCode !== "auth/cancelled-popup-request" && errorMessage !== "This operation has been cancelled due to another conflicting popup being opened.") {
      setAlertModalState(prevState => {
        return {
          ...prevState,
          "open": true,
          "header": "Couldn't open the sign-in window",
          "content": "This is likely because your browser blocks pop-ups. Please allow pop-ups for fevir.net"
        };
      });
    }
    console.log(e);
  });
  //return success;
}

const GoogleSignInButton = ({ firebaseGoogleProvider, firebaseEmailAuthProvider, setUserLoadingState, setAlertModalState, previousUrlState, setPreviousUrlState, redirect = false }) => {
  const dispatch = useDispatch();
  return <span>
    <button className="gsi-material-button" style={{ width: "222px" }}
      onClick={() => {
        googleSignInFirebase(firebaseGoogleProvider, firebaseEmailAuthProvider, dispatch, setUserLoadingState, setAlertModalState, previousUrlState, setPreviousUrlState, redirect);
      }}>
      <div className="gsi-material-button-state" />
      <div className="gsi-material-button-content-wrapper">
        <div className="gsi-material-button-icon">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style={{ display: "block" }}>
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
            <path fill="none" d="M0 0h48v48H0z" />
          </svg>
        </div>
        <span className="gsi-material-button-contents">Sign in with Google</span>
        <span style={{ display: "none" }}>Sign in with Google</span>
      </div>
    </button><span style={{ color: "#CC4444" }}> (recommended)</span>
  </span>
}

const handlePasswordReset = async (firebaseModalState, setAlertModalState) => {
  const email = firebaseModalState.email;
  const auth = getAuth();

  if (!email || !email.includes("@")) {
    setAlertModalState(prevState => ({
      ...prevState,
      "open": true,
      "header": "Email Required",
      "content": "Please enter a valid email address in the box above to reset your password."
    }));
    return;
  }

  try {
    await sendPasswordResetEmail(auth, email);
    setAlertModalState(prevState => ({
      ...prevState,
      "open": true,
      "header": "Email Sent",
      "content": `If you've signed up with this email before ${email}, a password reset link has been sent. Check your inbox (and spam folder).`
    }));
  } catch (error) {
    const errorCode = error.code;
    let errorMessage = "An error occurred. Please try again.";

    if (errorCode === "auth/user-not-found") {
      errorMessage = "No account found with this email address.";
    } else if (errorCode === "auth/invalid-email") {
      errorMessage = "The email address is not valid.";
    }

    setAlertModalState(prevState => ({
      ...prevState,
      "open": true,
      "header": "Error",
      "content": errorMessage
    }));
    console.error(error);
  }
};

//NOT COMPLETE LOOK AT TO DOs
const emailPasswordSignInFirebase = async (firebaseModalState, setFirebaseModalState, setWaitingForVerificationEmailState, setAlertModalState) => {
  let email = firebaseModalState.email;
  let password = firebaseModalState.password;
  const auth = getAuth();
  let cred = await signInWithEmailAndPassword(auth, email, password)
    .then(async (userCredential) => {
      // Signed in
      //console.log(userCredential);
      const user = userCredential.user;
      if (user) {
        if (!user.emailVerified) {
          await sendEmailVerification(user);
          auth.signOut()
            .then(() => {
              setFirebaseModalState(prevState => { return { ...prevState, 'open': false } });
              setAlertModalState(prevState => {
                return {
                  ...prevState,
                  "open": true,
                  "header": "Verify Your Email",
                  "content": "Please verify your email. Check your email's spam folder."
                };
              });
              setWaitingForVerificationEmailState(true);
              window.location.reload();
            })
            .catch((e) => { console.log(e); });
        } else {
          setFirebaseModalState(prevState => { return { ...prevState, 'open': false } });
          window.location.reload();
        }
      }
    })
    .catch(async (e) => {
      const errorCode = e.code;
      console.log(e);
      if (errorCode === "auth/invalid-credential" || errorCode === "auth/user-not-found") {

        let cred = await createUserWithEmailAndPassword(auth, email, password)
          .then(async (userCredential) => {
            // Signed up 
            //console.log(userCredential);
            const user = userCredential.user;
            if (user) {
              if (!user.emailVerified) {
                await sendEmailVerification(user);
                //signOutFirebase(globalContext)
                setAlertModalState(prevState => {
                  return {
                    ...prevState,
                    "open": true,
                    "header": "Verify Your Email",
                    "content": "Please verify your email. Check your email's spam folder."
                  };
                });
                setFirebaseModalState(prevState => { return { ...prevState, 'open': false } });
                setWaitingForVerificationEmailState(true);
                window.location.reload();
              }
            }
          })
          .catch((e) => {
            console.log(e);
            alert(e); //We'll keep this for now
            const errorCode = e.code;
            if (errorCode === "auth/email-already-in-use") {
              setAlertModalState(prevState => {
                return {
                  ...prevState,
                  "open": true,
                  "header": "Problem with that Sign-Up Email",
                  "content": "Either incorrect password or this email is already being used. Maybe try logging in via Google instead of Email / Password.\nOr click \"Forgot Password\" to do a password reset."
                };
              });
            }
          });
      } else if (errorCode === "auth/email-already-in-use") {
        setAlertModalState(prevState => {
          return {
            ...prevState,
            "open": true,
            "header": "Email Already In Use",
            "content": "This email is already being used. Maybe try logging in via Google instead of Email / Password.\nOr click \"Forgot Password\" to do a password reset."
          };
        });
      }
    });
  //console.log(cred);
  return;
}

const SignInFirebaseButtons = ({ firebaseModalState, setFirebaseModalState, firebaseGoogleProvider,
  firebaseEmailAuthProvider, setUserLoadingState, setAlertModalState, setWaitingForVerificationEmailState, previousUrlState, setPreviousUrlState, redirect }) => {
  return <>
    {!firebaseModalState.signInWithEmailAndPasswordPage ?
      <div style={{ padding: "0px 16px 0px 16px" }}>
        <br />
        <GoogleSignInButton firebaseGoogleProvider={firebaseGoogleProvider}
          firebaseEmailAuthProvider={firebaseEmailAuthProvider} setUserLoadingState={setUserLoadingState}
          setAlertModalState={setAlertModalState} previousUrlState={previousUrlState} setPreviousUrlState={setPreviousUrlState} redirect={redirect} />
        <br />
        <br />
        <button className="gsi-material-button"
          onClick={() => {
            setFirebaseModalState(prevState => { return { ...prevState, "signInWithEmailAndPasswordPage": true }; });
          }}>
          <div className="gsi-material-button-state" />
          <div className="gsi-material-button-content-wrapper">
            <span className="gsi-material-button-contents">Sign in with Email & Password</span>
            <span style={{ display: "none" }}>Sign in with Email & Password</span>
          </div>
        </button>
        {/*
          <br />
          <br />
          <button className="gsi-material-button"
            onClick={() => {
              globalContext.setFirebaseModalState(prevState => { return { ...prevState, "signInWithEmailPage": true }; });
            }}>
            <div className="gsi-material-button-state" />
            <div className="gsi-material-button-content-wrapper">
              <span className="gsi-material-button-contents">Sign in with Email</span>
              <span style={{ display: "none" }}>Sign in with Email</span>
            </div>
          </button>
          */}
        <br />
        <br />
      </div>
      :
      <div>
        <br />
        <TextField required style={{ margin: "8px", width: "90%" }} className="inputField" type='text' label={'Email'}
          size="small" variant='outlined' value={firebaseModalState.email}
          onChange={(e) => {
            setFirebaseModalState(prevState => { return { ...prevState, email: e.target.value } });
          }}
        />
        <br />
        <TextField required style={{ margin: "8px", width: "90%" }} className="inputField" type='password' label={'FEvIR Password'}
          size="small" variant='outlined' value={firebaseModalState.password}
          onChange={(e) => {
            setFirebaseModalState(prevState => { return { ...prevState, password: e.target.value } });
          }}
        />
        <br />
        <br />
        <Button className="formButton" style={{ color: "#000000", marginLeft: "8px" }}
          content={`Sign In / Create Account`}
          disabled={!firebaseModalState.password || !firebaseModalState.email || !firebaseModalState.email.includes("@")}
          onClick={async () => {
            emailPasswordSignInFirebase(firebaseModalState, setFirebaseModalState, setWaitingForVerificationEmailState, setAlertModalState);
          }} />
        {/* createUserWithEmailAndPassword 
              emailPasswordSignInFirebase(globalContext);
              globalContext.firebaseEmailAuthProvider
          */}
        <br />
        <br />
        <a
          style={{ marginLeft: "10px" }}
          onClick={(e) => {
            e.preventDefault();
            handlePasswordReset(firebaseModalState, setAlertModalState);
          }}>
          Forgot Password?
        </a>
        <br />
        <br />
      </div>
    }
  </>;
}

const SignInFirebaseModal = ({ firebaseModalState, setFirebaseModalState, firebaseGoogleProvider,
  firebaseEmailAuthProvider, setUserLoadingState, setAlertModalState, setWaitingForVerificationEmailState, redirect = false, previousUrlState, setPreviousUrlState }) => {
  const userId = useSelector(selectCurrentUserId);
  const displayTheTermsOfAgreement = useSelector(selectDisplayTheTermsOfAgreement);

  const modalClose = () => {
    setFirebaseModalState(prevState => { return { ...prevState, "open": false, "signInWithEmailAndPasswordPage": false, "email": "", "password": "" }; });
  }

  useEffect(() => {
    if ((userId && userId !== "1") || displayTheTermsOfAgreement) { //To handle whether it's a string or an integer, if confirmed as a string then another equals sign can be added
        modalClose();
    }
  }, [userId, displayTheTermsOfAgreement]);

  useEffect(() => {
    //This is to fix the "The requested action is invalid." Firebase popup error message
    //This temporary redirects the website tab to "https://fevir.net" in URL only if the sign in modal is open, and changesthe URL back when the modal is closed
    if (firebaseModalState.open) {
      let previousUrl = window.location.href;
      window.history.replaceState(null, "", "/");
      if (previousUrl.indexOf("termsofagreement") === -1) {
        setPreviousUrlState(previousUrl);
      }
    } else if (previousUrlState) {
      let previousUrl = previousUrlState;
      window.history.replaceState(null, "", previousUrl);
      setPreviousUrlState(null);
    }
  }, [firebaseModalState.open]);

  return <Modal
    style={{ width: "450px", margin: "16px" }}
    dimmer={<Modal.Dimmer blurring style={{ backgroundColor: "#00000077" }} />}
    open={firebaseModalState.open}
    centered={false}
    content={<div style={{ whiteSpace: "pre-wrap" }} onKeyUp={(e) => { if (e.key === "Enter") { modalClose(); } }}>
      <Button style={{ padding: "6px", position: "absolute", top: "6px", right: "6px" }} className="formButton negative" content="✖"
        onClick={modalClose} />
      <Modal.Header style={{ padding: "6px 16px 0px 16px", color: "#AC3B61" }}><h2>Please sign in or create an account</h2></Modal.Header>
      <br />
      <SignInFirebaseButtons firebaseModalState={firebaseModalState}
        setFirebaseModalState={setFirebaseModalState} firebaseGoogleProvider={firebaseGoogleProvider}
        firebaseEmailAuthProvider={firebaseEmailAuthProvider} setUserLoadingState={setUserLoadingState} previousUrlState={previousUrlState} setPreviousUrlState={setPreviousUrlState}
        setAlertModalState={setAlertModalState} setWaitingForVerificationEmailState={setWaitingForVerificationEmailState} redirect={redirect} />
    </div>}
    closeOnEscape
    closeOnDimmerClick
    onClose={modalClose}
  />
}

const userLogin = (dispatch, setUserLoadingState, previousUrlState, setPreviousUrlState, redirect = false) => {
  const auth = getAuth();
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    const code = window.location.search.split("customtokencode=")[1]?.split('&')[0];
    if (user) {
      setUserLoadingState(true);
      let idToken;
      try {
        idToken = await getIdToken(user, true);
        //setIdTokenState({ idToken: idToken, tokenPresent: true });
      } catch (error) {
        console.error("Error getting ID token:", error);
        //setIdTokenState({ idToken: '', tokenPresent: false });
        setUserLoadingState(false);
      }
      try {
        if (idToken) {
          await loadUserDataToSlice(idToken, previousUrlState, setPreviousUrlState, dispatch, redirect);
          /* //TODO TO DO SSO single sign-on September 8
          const params = new URLSearchParams(props.location.search);
          let redirect = params.get('redirect') || undefined;
          if (redirect) {
            let decodedRedirect = decodeURIComponent(redirect);
            let domainLength = computablepublishing_website_address.length;
            let charAfter = decodedRedirect.charAt(domainLength);
            if ((decodedRedirect.substring(0, domainLength) === computablepublishing_website_address
              || (window.location.hostname == "localhost" && decodedRedirect.substring(0, domainLength) === "http://localhost:3001/"))
              && (!charAfter || charAfter === "/" || charAfter === "?" || charAfter === "#")) {
                let redirectURL = decodedRedirect;
                const ssoCustomTokenCode = await createCustomToken(idToken, apiToken);
                if (ssoCustomTokenCode) {
                  redirectURL += "?customtokencode=" + ssoCustomTokenCode;
                  window.location.assign(redirectURL);
                } else {
                  console.log("sso failed")
                  redirectURL += "/ssofailed";
                  //Asks the user to login, AND THEN redirect if successful
                  window.location.assign(redirectURL);
                }
            }
          }
        */
        }
        /* else if ('indexedDB' in window) { //Will only continue writing this code if we ever have a problem with the new site has trouble automatically logging in/continuing a session
          await getRefreshedIdToken(); //Not completed code, see the old FEvIR repo on how this is done
          await loadUserDataToSlice(idToken, dispatch, false);
        }*/
      } catch (error) {
        console.error("Error getting loading user data:", error);
        setUserLoadingState(false);
      }
    } else if (code) {
      setUserLoadingState(true);
      await processCustomTokenCode(code);
    } else {
      dispatch(userLoggedOut());
    }
    setUserLoadingState(false);
  });
  return unsubscribe;
};

const App = ({ firebaseGoogleProvider, firebaseEmailAuthProvider }) => {
  //const params = new URLSearchParams(location.search);
  //const redirect = params.get('redirect');
  const redirect = false; //TODO TO DO September 8, for SSO for the ComputablePublishing.com login and the this will redirect from FEvIR back
  const [userLoadingState, setUserLoadingState] = useState(true);
  const [previousUrlState, setPreviousUrlState] = useState(null);
  const [firebaseModalState, setFirebaseModalState] = useState({ open: false, email: "", password: "" });
  //const [idTokenState, setIdTokenState] = useState({ "idToken": "", "tokenPresent": false });
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isM11PanelOpen, setIsM11PanelOpen] = useState(false);
  const [m11ToolState, setM11ToolState] = useState(false);
  const [alertModalState, setAlertModalState] = useState({
    open: false, alertHistory: [], header: "", content: ""
  });
  const [waitingForVerificationEmailState, setWaitingForVerificationEmailState] = useState(false);
  const [panelWidth, setPanelWidth] = useState(() => Math.min(440, window.innerWidth * 0.2));

  const dispatch = useDispatch();
  const m11User = useSelector(selectCurrentUserM11Use);
  const handleFloatingButtonClick = () => {
    setIsPanelOpen(!isPanelOpen);
    setIsM11PanelOpen(false);
  };
  const handleFloatingButtonClick2 = () => {
    setIsM11PanelOpen(!isM11PanelOpen);
    setIsPanelOpen(false);
  };
  const browserTabTitle = useSelector(selectBrowserTabTitle);
  const siteIsLoading = useSelector(selectGlobalLoading);
  const componentIsLoading = useSelector(selectComponentLoading);
  const websiteView = useSelector(selectWebsiteView);
  const apiToken = useSelector(selectCurrentUserApiToken);
  const userId = useSelector(selectCurrentUserId);

  useEffect(() => {
    if (window.location.href.includes("dev.fevir.net") || window.location.href.includes("localhost")) {
      dispatch(changeEnvironment("Development FEvIR"));
    } else {
      dispatch(changeEnvironment("FEvIR"));
    }
  }, []);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = browserTabTitle;
    return () => {
      document.title = prevTitle;
    }
  }, [browserTabTitle]);

  useEffect(() => {
    const unsubscribe = userLogin(dispatch, setUserLoadingState, previousUrlState, setPreviousUrlState, redirect);
    return () => unsubscribe();
  }, [dispatch, setUserLoadingState]);

  return (
    <div
      id="appdiv"
      className={`App ${(isPanelOpen || isM11PanelOpen) ? 'panel-open' : ''} ${websiteView}View`}
      style={isPanelOpen || isM11PanelOpen ? { '--panel-width': `${panelWidth}px` } : {}}
    >
      {(apiToken || userId === "1" || userId === 0) &&
        <ToastProvider autoDismiss autoDismissTimeout={5000} placement="bottom-left" >
          <button className="floating-button" onClick={handleFloatingButtonClick}>📝</button>{/* 📋 */} {/* ✏️ */}
          {m11ToolState && <button className="floating-button-2" onClick={handleFloatingButtonClick2}>M11</button>}
          {m11User && <M11SidePanel isOpen={isM11PanelOpen} panelWidth={panelWidth} setPanelWidth={setPanelWidth} />}
          <SidePanel isOpen={isPanelOpen} panelWidth={panelWidth} setPanelWidth={setPanelWidth} />
          {(siteIsLoading || componentIsLoading > 0) &&
            <Dimmer className={"loadingDimmer"} active inverted>
              <Loader inverted>Loading....</Loader>
            </Dimmer>
          }
          <AlertModal alertModalState={alertModalState} setAlertModalState={setAlertModalState} />
          <SignInFirebaseModal firebaseModalState={firebaseModalState}
            setFirebaseModalState={setFirebaseModalState} firebaseGoogleProvider={firebaseGoogleProvider}
            firebaseEmailAuthProvider={firebaseEmailAuthProvider} setUserLoadingState={setUserLoadingState}
            setAlertModalState={setAlertModalState} previousUrlState={previousUrlState} setPreviousUrlState={setPreviousUrlState}
            setWaitingForVerificationEmailState={setWaitingForVerificationEmailState} redirect={redirect} />
          <Router>
            <RemoveTrailingCharacters />
            {/**  <ScrollToTop /> */}
            <main>
              <header className="App-header"
                style={{ display: window.location.pathname.match('/noheader/') ? "none" : "flex" }}>
                <PageTitle />
                <Navbar userLoadingState={userLoadingState} setFirebaseModalState={setFirebaseModalState} />
              </header>
              <div className="appBody">
                <Routes>
                  {window.location.href.includes("computablepublishing.com") &&
                    <Route path="" exact element={<Homepage />} />}
                  <Route path="" exact element={<FEvIRHomePage />} />
                  <Route path="/futureFEvIR" exact element={<FEvIRHomePage />} />
                  <Route path="/FOI" exact element={<FOIPage />} />
                  <Route path="/content/myresources" exact element={<ContentResourcesPage />} />
                  <Route path="/content/resources" exact element={<ContentResourcesPage />} />
                  <Route path="/myresources" exact element={<ContentResourcesPage />} />
                  <Route path="/favorites" exact element={<ContentResourcesPage />} />
                  <Route path="/favorite" exact element={<ContentResourcesPage />} />
                  <Route path="/bookmarks" exact element={<ContentResourcesPage />} />
                  <Route path="/bookmark" exact element={<ContentResourcesPage />} />
                  <Route path="/resources" exact element={<ContentResourcesPage />} />
                  <Route path="/notifications" exact element={<ContentResourcesPage />} />
                  <Route path="/savedsearches" exact element={<SavedSearchesPage />} /> {/* For now for quicker development */}
                  <Route path="/search" exact element={<SearchQueryPage />} />
                  <Route path="/m11report" exact element={<M11ReportPage />} />
                  <Route path="/m11report/:foi?" exact element={<M11ReportAuthoringTool setM11ToolState={setM11ToolState} />} />
                  <Route path="/m11report/:foi?/step/:step?" exact element={<M11ReportAuthoringTool setM11ToolState={setM11ToolState} />} />
                  <Route path="/medlineconvert" exact element={<MedlineConvertPage />} />
                  <Route path="/ctgovconvert" exact element={<CTgovConvertPage />} />
                  <Route path="/ctisconvert" exact element={<CtisConvertPage />} />
                  <Route path="/MAGIC" exact element={<MAGICtoFEvIRConverterPage />} />
                  <Route path="/GRADEpro" exact element={<GradeProConverterPage />} />
                  <Route path="/ris" exact element={<RIStoFEvIRConverterPage />} />
                  <Route path="/usdm" exact element={<USDMtoFEvIRConverterPage />} />
                  <Route path="/usdmconvert" exact element={<USDMtoFEvIRConverterPage />} />
                  <Route path="/docxtojsonsections" exact element={<DocxToJsonSectionsConverterPage />} />
                  <Route path="/myballot" exact element={<MyBallotPage />} />
                  <Route path="/apidoc" exact element={<ApiDocumentationPage />} />
                  <Route path="/admin" exact element={<AdminPage />} />
                  <Route path="/admin2" exact element={<AdminPage2 />} />
                  <Route path="/admin3" exact element={<AdminPage3 />} />
                  <Route path="/jsonentry" exact element={<CreateResourcePage />} />
                  <Route path="/fhirentry" exact element={<CreateResourcePage />} />
                  <Route path="/create" exact element={<CreateResourcePage />} />
                  <Route path="/create/:resourcetype?" exact element={<CreateResourcePage />} />
                  <Route path="/create/:resourcetype?/:foi?" exact element={<CreateResourcePage />} />
                  <Route path="/createcer" exact element={<CreateComparativeEvidenceReport />} />
                  <Route path="/createcesr" exact element={<CreateComparativeEvidenceSynthesisReport />} />
                  <Route path="/createguideline" exact
                    element={<ProfileSpecificCreateResourcePage resourceType="Composition"
                      resourceStarter={{
                        "resourceType": "Composition",
                        "meta": { "profile": ["http://hl7.org/fhir/uv/ebm/StructureDefinition/guideline"] },
                        "title": "",
                        "type": compositionTypeCodeGuideline,
                        "section": ProfilesByResourceType.Composition.Guideline.sectionStarter
                      }} />} />
                  <Route path="/createrecommendation" exact
                    element={<ProfileSpecificCreateResourcePage resourceType="Composition"
                      resourceStarter={{
                        "resourceType": "Composition",
                        "meta": { "profile": ["http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation"] },
                        "title": "",
                        "type": compositionTypeCodeRecommendation,
                        "section": ProfilesByResourceType.Composition.Recommendation.sectionStarter
                      }} />} />
                  <Route path="/createcohortdefinition" exact
                    element={<ProfileSpecificCreateResourcePage resourceType="Group"
                      resourceStarter={{
                        "resourceType": "Group",
                        "membership": "conceptual",
                        "title": "",
                        "name": "",
                        "characteristic": []
                      }} />} />
                  <Route path="/createcitation" exact element={<CreateNewCitationPage />} />
                  <Route path="/createcodeableconcept" exact element={<CreateCodeableConceptJsonPage />} />
                  <Route path="/invite/:inviteCode?" exact element={<InvitedToResourcePage />} />
                  <Route path="/jsonbulkentry" exact element={<JsonBulkEntryPage />} />
                  <Route path="/UDP" exact element={<UDPPage />} />
                  <Route path="/malariaCameroon" exact
                    element={<Navigate to="/resources/Composition/270746" replace />} />
                  <Route path="/MalariaGuidelinesCameroon" exact
                    element={<Navigate to="/resources/Composition/270746" replace />} />
                  <Route path="/StopMalariaInCameroon" exact
                    element={<Navigate to="/resources/Composition/270746" replace />} />
                  <Route path="/hevka" exact
                    element={<Navigate to="/resources/Composition/29272" replace />} />
                  <Route path="/FLI" exact element={<FliToFoiPage />} />
                  <Route path="/flitofoi" exact element={<FliToFoiPage />} />
                  <Route path="/flitofoi/:fli?" exact element={<FliToFoiPage />} />
                  <Route path="/FLI/:foi?" exact element={<ResourceDisplayPage fliAttempt={true} />} /> {/* That foi variable is actually an FLI in this scenario */}
                  <Route path="/resources/:foi?" exact element={<ResourceDisplayPage />} /> {/* URL redirect works */}
                  <Route path="/resources/:resource_type?/:foi?" exact element={<ResourceDisplayPage />} /> {/* URL redirect works */}
                  <Route path="/resources/:resource_type?/:foi?/edit" exact element={<ResourceDisplayPage editmode={true} />} /> {/* URL redirect works */}
                  <Route path="/FOI/:foi?" exact element={<ResourceDisplayPage />} /> {/* URL redirect works */}
                  <Route path="/FOI/:foi?/edit" exact element={<ResourceDisplayPage editmode={true} />} /> {/* URL redirect works */}
                  <Route path="/NetBenefitCalculator/:foi?" exact element={<NetBenfitRedirect />} />
                  <Route path="/:foi?" exact element={<ResourceDisplayPage />} /> {/* URL redirect works */}
                  <Route path="/:resource_type?/:foi?" exact element={<ResourceDisplayPage />} /> {/* URL redirect works */}
                  <Route path="/:resource_type?/:foi?/edit" exact element={<ResourceDisplayPage editmode={true} />} /> {/* URL redirect works */}
                  {/* <Route path="/Composition/:foi?" exact element={<ResourceDisplayPage />} /> */} {/* TODO, can we remove this one now since it can't be accessed because it's covered by an earlier route /:resource_type?/:foi? */}

                  <Route path="/radar" exact element={<MeasuringTheRateCreationPage />} />
                  <Route path="/radar/:investigationId?" exact element={<MeasuringTheRatePage setFirebaseModalState={setFirebaseModalState} />} />
                  <Route path="/mission" exact element={<Mission />} />
                  <Route path="/blog" exact element={<Mission />} />
                  <Route path="/the-mission-change-of-a-lifetime" exact element={<Mission />} />
                  <Route path="/about" exact element={<About />} />
                  <Route path="/dynamed-founder-launches-computable-publishing-llc" exact element={<CompanyLaunch />} />
                  <Route path="/media" exact element={<Media />} />
                  <Route path="/media/:itemId" exact element={<SingleMediaPage />} />
                  <Route path="/releasenotes" exact element={<ReleaseNotesPage />} />
                  <Route path="/toolnotes/:toolName?" exact element={<ReleaseNotesPage />} />
                  <Route path="/releasenotes/:itemId" exact element={<EditReleaseNotePage />} />
                  <Route path="/products" exact element={<Products />} />
                  <Route path="/termsofuse" exact element={<TermsOfUsePage />} />
                  <Route path="/personaldataagreement" exact element={<PersonalDataAgreementPage />} />
                  <Route path="/termsofagreement" exact element={<TermsOfAgreementPage
                    waitingForVerificationEmail={waitingForVerificationEmailState}
                    previousUrlState={previousUrlState} setPreviousUrlState={setPreviousUrlState}
                  />} />
                  <Route path="/editprofile" exact element={<EditUserProfilePage
                    setAlertModalState={setAlertModalState} />} />
                  <Route path="/userremoval" exact element={<UserRemovalPage />} />
                  <Route path="/testingspace" exact element={<TestingSpacePage />} />

                  <Route path="/ctrr" exact element={<RedirectSite page="https://computablepublishing.us/ctrr/" />} /> {/* ctrr.html */}
                  {/**TODO -- these are unused Routes to delete. 
                 * Note the Suspense function that may be useful for routes that require login
                 * The 'Suspense' action appears to be used with the lazy function
                <Route path="/Composition" exact element={<Suspense><GetCompositionByFOI /></Suspense>} />
                <Route path="/getcomposition" exact element={<Suspense><GetCompositionByFOI /></Suspense>} />
                <Route path="/getbundle" exact element={<Suspense><GetBundleByFOI /></Suspense>} />
                <Route path="/Bundle/:foi" exact element={<Suspense><GetBundleByFOI /></Suspense>} />
                <Route path="/counter" exact element={<>
                  <Counter />
                  <p>
                    Edit <code>src/App.tsx</code> and save to reload.
                  </p>
                  <Quotes />
                  <span>
                    <span>Learn </span>
                    <a
                      className="App-link"
                      href="https://reactjs.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      React
                    </a>
                    <span>, </span>
                    <a
                      className="App-link"
                      href="https://redux.js.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Redux
                    </a>
                    <span>, </span>
                    <a
                      className="App-link"
                      href="https://redux-toolkit.js.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Redux Toolkit
                    </a>
                    <span>, </span>
                    <a
                      className="App-link"
                      href="https://react-redux.js.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      React Redux
                    </a>
                    ,<span> and </span>
                    <a
                      className="App-link"
                      href="https://reselect.js.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Reselect
                    </a>
                  </span></>}
                />
                */}
                  <Route path="/ComputablePublishing" exact element={<Homepage />} /> {/*For local Development*/}
                  <Route path="/pagenotfound" exact element={<h1><br />Page Not Found</h1>} />
                  <Route path="*" exact element={<h1><br />Page Not Found</h1>} />
                </Routes>
              </div>
              {/* <br /> bring this back if removing it breaks anything like the footer overlapping with content*/}
              <Footer />
            </main>
          </Router>
        </ToastProvider>
      }
    </div>
  )
}


addMediaListeners();
addReleaseNotesListeners();
addResourceCollectionListeners();
addNotificationsListeners();
addSavedSearchesListeners();
//addOutcomeImportanceListeners();
//addBaselineRiskListeners();
//addOutcomeVariablesListeners();
//addCurrentUserListeners();

export default App;